import React from 'react';
import './App.css';
import AuthWrapper from './wrappers/AuthWrapper';
import { Main } from './containers';
import Header from './presenters/Header';
import { de } from 'date-fns/esm/locale';
import { registerLocale } from 'react-datepicker';

registerLocale('de', de);

const App = () => {
  return (
    <AuthWrapper>
      <Header />
      <div className="wrapper">
        <Main />
      </div>
    </AuthWrapper>
  );
};

export default App;
